// extracted by mini-css-extract-plugin
export default {"mainCont":"HomePage_mainCont__Qp3Ry"};